import { render } from "./scroll-to-top-button.vue?vue&type=template&id=5c9412e1"
import script from "./scroll-to-top-button.vue?vue&type=script&lang=js"
export * from "./scroll-to-top-button.vue?vue&type=script&lang=js"

import "./scroll-to-top-button.vue?vue&type=style&index=0&id=5c9412e1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__